import { render } from "./TemplateComponent.vue?vue&type=template&id=0d5db95a&ts=true"
import script from "./TemplateComponent.vue?vue&type=script&lang=ts"
export * from "./TemplateComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__